import FeatureCard from "./FeatureCard";
import { Plane, Hotel, Calendar, Cloud, Train, Map, Newspaper } from "lucide-react";

const FeaturesSection = () => {
  const features = [
    {
      title: "Flight Search",
      description: "Find the best flights with personalized filtering options.",
      icon: <Plane className="w-8 h-8" />,
      path: "/flights",
    },
    {
      title: "Hotel Search",
      description: "Discover accommodations that match your preferences and budget.",
      icon: <Hotel className="w-8 h-8" />,
      path: "/itinerary",
    },
    {
      title: "Weather Forecast",
      description: "Check the weather conditions for your destination dates.",
      icon: <Cloud className="w-8 h-8" />,
      path: "/weather",
    },
    {
      title: "Itinerary Generator",
      description: "Create personalized daily plans for your entire trip.",
      icon: <Calendar className="w-8 h-8" />,
      path: "/itinerary",
    },
    {
      title: "Tour Guide",
      description: "Get detailed information about attractions and local tips.",
      icon: <Map className="w-8 h-8" />,
      path: "/itinerary",
    },
    {
      title: "Destination News",
      description: "Stay updated with the latest news and events from your destination.",
      icon: <Newspaper className="w-8 h-8" />,
      path: "/itinerary",
    },
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="travel-container">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-4">Plan Every Aspect of Your Trip</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Our comprehensive suite of AI-powered travel tools helps you plan the perfect journey from start to finish.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature) => (
            <FeatureCard
              key={feature.title}
              title={feature.title}
              description={feature.description}
              icon={feature.icon}
              path={feature.path}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
